export default "__VITE_ASSET__98982122__"